import { Component } from '@angular/core';

@Component({
  selector: 'itl-single-order-article-list-item-button',
  templateUrl: './single-order-article-list-item-button.component.html',
  styleUrls: ['./single-order-article-list-item-button.component.scss'],
})
export class SingleOrderArticleListItemButtonComponent {}
